import { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router";
import { ScrollToHash } from "@/app/scroll-to-hash";
import { NgonLogo } from "@/components/brand/NgonLogo";

export function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToHash />
      <PublicNav />
      <main className="flex-1">
        <Outlet />
      </main>
      <PublicFooter />
    </div>
  );
}

function PublicNav() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);

  return (
    <nav className="sticky top-0 z-20 border-b border-border bg-surface/85 backdrop-blur-md">
      <div className="mx-auto max-w-[1200px] px-4 sm:px-6">
        <div className="flex items-center gap-4">
          <NavLink
            to="/"
            className="py-3.5 text-text"
          >
            <NgonLogo markClassName="size-9" />
          </NavLink>
          <div className="hidden items-stretch md:flex">
            <PublicLink to="/hire">Hire talent</PublicLink>
            <PublicLink to="/jobs">Find a job</PublicLink>
          </div>
          <div className="ml-auto hidden items-stretch md:flex">
            <PublicLink to="/#about">About</PublicLink>
            <PublicLink to="/#contact">Contact</PublicLink>
          </div>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="ml-auto inline-flex items-center justify-center rounded-md border border-border bg-surface px-3 py-2 text-sm font-medium text-text md:hidden"
            aria-expanded={open}
            aria-label={open ? "Close navigation" : "Open navigation"}
          >
            {open ? "Close" : "Menu"}
          </button>
        </div>

        <div className={open ? "border-t border-border pb-3 md:hidden" : "hidden"}>
          <div className="flex flex-col pt-2">
            <PublicLink to="/hire">Hire talent</PublicLink>
            <PublicLink to="/jobs">Find a job</PublicLink>
            <PublicLink to="/#about">About</PublicLink>
            <PublicLink to="/#contact">Contact</PublicLink>
          </div>
        </div>
      </div>
    </nav>
  );
}

function PublicLink({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      end={to === "/"}
      className={({ isActive }) =>
        `relative inline-flex items-center px-3 py-3.5 text-sm font-medium transition-colors ${
          isActive
            ? "text-text after:absolute after:bottom-[-1px] after:left-3 after:right-3 after:h-[2px] after:rounded-full after:bg-primary"
            : "text-text-muted hover:text-text"
        }`
      }
    >
      {children}
    </NavLink>
  );
}

function PublicFooter() {
  return (
    <footer className="border-t border-border bg-surface px-4 py-10 sm:px-6">
      <div className="mx-auto flex max-w-[1100px] flex-col gap-5 text-[13px] text-text-muted sm:flex-row sm:flex-wrap sm:items-center sm:justify-between">
        <div>© 2026 NGON Tech. Outstaffing & recruiting for software teams.</div>
        <div className="flex flex-wrap gap-4 sm:gap-6">
          <NavLink to="/hire">Hire talent</NavLink>
          <NavLink to="/jobs">Find a job</NavLink>
        </div>
      </div>
    </footer>
  );
}
